import {
    GET_ADMIN_PLATFORM_SETTNGS,
    GET_ADMIN_PLATFORM_SETTNGS_SUCCESS,
    GET_ADMIN_PLATFORM_SETTNGS_ERROR,
    UPDATE_ADMIN_PLATFORM_SETTNGS,
    UPDATE_ADMIN_PLATFORM_SETTNGS_SUCCESS,
    UPDATE_ADMIN_PLATFORM_SETTNGS_ERROR,
} from "./actionTypes"

const INIT_STATE = {
    admin_platform_settings: {},
    error: null,
    loading: false,
    update_loading: false
}
      
const AdminPlatformSettings = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ADMIN_PLATFORM_SETTNGS:
            return {
                ...state,
                loading: true
            }

        case GET_ADMIN_PLATFORM_SETTNGS_SUCCESS:
            return {
                ...state,
                loading: false,
                admin_platform_settings: action.payload
            }

        case GET_ADMIN_PLATFORM_SETTNGS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        case UPDATE_ADMIN_PLATFORM_SETTNGS:
            return {
                ...state,
                update_loading: true
            }

        case UPDATE_ADMIN_PLATFORM_SETTNGS_SUCCESS:
            return {
                ...state,
                update_loading: false,
                admin_platform_settings: action.payload
            }

        case UPDATE_ADMIN_PLATFORM_SETTNGS_ERROR:
            return {
                ...state,
                update_loading: false,
                error: action.payload
            }

        default:
            return state
    }
}

export default AdminPlatformSettings
